export default [
    {
        key: 'DistributePayeeAccountModal',
        getComponent: function () { return import('./DistributePayeeAccountModal'); },
        title: i18n.get('收款账户'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'AutomaticDistributeModal',
        getComponent: function () { return import('./AutomaticDistributeModal'); },
        title: i18n.get('收款账户'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
